import React from "react";
import { Accordion } from "react-bootstrap";

const TabSingleAccordion = ({eventKey, question, answer}) => {
  return (
    <Accordion.Item eventKey={eventKey} >
      <Accordion.Header>{question}</Accordion.Header>
      <Accordion.Body>{answer}</Accordion.Body>
    </Accordion.Item>
  );
};

export default TabSingleAccordion;
